import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateRecalculateRequiredWidgetHeight } from '../../Lib/redux/slices/dynamicHeight';

/**
 * Refreshes the widget sizing on an internal view change: dynamic-height forms
 * request a height recalculation, static-height forms nudge the scroll
 * container to re-measure. Re-runs whenever `dependencies` change. Pass
 * `delayMs` to defer the refresh (e.g. until an expand/collapse animation has
 * settled) so the new height is measured, not the mid-transition one.
 */
export const useWidgetHeightRefresh = (dependencies, delayMs = 0) => {
  const dispatch = useDispatch();
  const isDynamicHeightEnabled = useSelector(
    (store) => store.optionalFormConfig?.isDynamicHeightEnabled
  );

  useEffect(() => {
    const refresh = () => {
      if (isDynamicHeightEnabled) {
        dispatch(
          updateRecalculateRequiredWidgetHeight({
            isWidgetHeightRecalculationRequired: true,
          })
        );
        return;
      }
      window.dispatchEvent(new Event('resize'));
    };

    if (delayMs > 0) {
      const timer = setTimeout(refresh, delayMs);
      return () => clearTimeout(timer);
    }

    refresh();
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useWidgetHeightRefresh;
